import './GenericDataTable.scss';
import { DataTable } from 'primereact/datatable'
import React from 'react';

const GenericDataTable=React.forwardRef(({children, padding , spacedRows,...restProps},ref)=>
{
  let customClasses = ``

  if (spacedRows) {
    customClasses += ' Spaced '
  }
  if(padding){
    customClasses +="Padding"
  }

  return (
    <DataTable responsiveLayout='scroll' className={`GenericDataTable ${customClasses}`} {...restProps} ref={ref} >
      {children}
    </DataTable>
  )
}

) 

GenericDataTable.defaultProps = {
  value: [],
  spacedRows: false,
  padding:false
}

export default GenericDataTable